import * as React from "react";
import {
	NameView,
	InfoViewGrid1,
	InfoViewGrid2,
	PriceView,
	OriginalPriceView,
	CollectViewOrange,
	InfoBottomStyle2,
	NameViewWithTag,
	InfoBottomLeftText,
	InfoViewGridBase,
	ActTagViewForMGrid,
	ScoreTextView,
} from "./styles";
import { ModuleLayoutStyle } from "../../../services/playground";
import { PoolExtraCollectInfo, ProductExtend, ScoreOption } from "../../../services/product";
import { CommentStarForM } from "../../../components/CommentStar";
import { isValidNumber } from "utils/number";
import { oneMoreWords } from "utils/string";
import { ProductCurrencyPrice } from "utils/playground/product";

export interface InfoViewGridsProps extends ProductCurrencyPrice {
	columnNum: number;
	name: string;
	price: string;
	originPrice: string;
	titleIcon?: string;
	collect?: PoolExtraCollectInfo;
	actTags?: string[];
	layoutStyle: ModuleLayoutStyle;
	isRollable?: boolean;
	collectOptions?: ScoreOption;
	displayInfo?: ProductExtend;
}

export const ProductInfoGrid1 = (props: InfoViewGridsProps) => {
	const {
		name,
		price,
		originPrice,
		priceCurrency,
		originPriceCurrency,
		priceSymbol,
		originPriceSymbol,
		collect,
		actTags,
		collectOptions = {},
	} = props;

	return (
		<InfoViewGrid1>
			<section>
				{NameViewGrid(name, 1, { fixedCol: actTags ? 1 : undefined })}
				{actTags && <ActTagViewForM actTags={actTags} />}
				{PriceViews({
					productPrice: {
						price,
						originPrice,
						priceCurrency,
						originPriceCurrency,
						priceSymbol,
						originPriceSymbol,
					},
					columnNum: 1,
				})}
			</section>
			<InfoBottomStyle2 gridCol={1}>
				{isValidNumber(collect?.score) ? (
					<>
						<CommentStarForM
							rateScore={+(collect?.score || 0)}
							settingOption={collectOptions}
						>
							{collectOptions?.widthScore ? (
								<ScoreTextView>
									{oneMoreWords(collect?.score?.toString())}
								</ScoreTextView>
							) : null}
						</CommentStarForM>
					</>
				) : (
					<InfoBottomLeftText>{collect?.score}</InfoBottomLeftText>
				)}
				{collect && CollectViews({ collect })}
			</InfoBottomStyle2>

		</InfoViewGrid1>
	);
};

export const ProductInfoGrid2 = (props: InfoViewGridsProps) => {
	const {
		name,
		price,
		originPrice,
		priceCurrency,
		originPriceCurrency,
		priceSymbol,
		originPriceSymbol,
		titleIcon = "",
		actTags,
		displayInfo,
	} = props;
	return (
		<InfoViewGrid2>
			{!displayInfo?.hideTitle && (
				<>
					{NameViewGrid(name, 2, { titleIcon, fixedCol: actTags ? 1 : undefined })}
					{actTags && <ActTagViewForM actTags={actTags} />}
				</>
			)}
			{PriceViews({
				productPrice: {
					price,
					originPrice,
					priceCurrency,
					originPriceCurrency,
					priceSymbol,
					originPriceSymbol,
				},
				columnNum: 2,
				layout: { hasLineBreak: displayInfo?.priceHasLineBreak },
			})}
			{RenderGrid2Collect(props)}
		</InfoViewGrid2>
	);
};
function RenderGrid2Collect({ displayInfo, collect, collectOptions = {} }: InfoViewGridsProps) {
	if (displayInfo?.hideCollection) {
		return null;
	}
	if ((!collectOptions?.withStar || !collect?.score) && !collect?.text) {
		return null;
	}

	return (
		<InfoBottomStyle2 gridCol={2}>
			{isValidNumber(collect?.score) ? (
				<>{RenderGrid2Star({ collect, collectOptions })}</>
			) : null}
			{collect && CollectViews({ collect })}
		</InfoBottomStyle2>
	);
}
function RenderGrid2Star({
	collectOptions = {},
	collect,
}: Pick<InfoViewGridsProps, "collect" | "collectOptions">) {
	if (!collectOptions?.withStar) {
		return null;
	}
	return (
		<CommentStarForM rateScore={+(collect?.score || 0)} settingOption={collectOptions}>
			{collectOptions?.widthScore && (
				<ScoreTextView>{oneMoreWords(collect?.score?.toString())}</ScoreTextView>
			)}
		</CommentStarForM>
	);
}
export const ProductInfoGrid3 = (props: InfoViewGridsProps) => {
	const {
		price,
		originPrice,
		priceCurrency,
		originPriceCurrency,
		priceSymbol,
		originPriceSymbol,
	} = props;

	return (
		<InfoViewGridBase>
			{PriceViews({
				productPrice: {
					price,
					originPrice,
					priceCurrency,
					originPriceCurrency,
					priceSymbol,
					originPriceSymbol,
				},
				layout: { hasLineBreak: true },
				columnNum: 3,
			})}
		</InfoViewGridBase>
	);
};
interface NameViewGridProps {
	titleIcon?: string;
	fixedCol?: number;
}
export const NameViewGrid = (
	name: string,
	columnNum: number,
	{ titleIcon, fixedCol }: NameViewGridProps,
) => {
	return (
		<NameView gridCol={columnNum} fixedCol={fixedCol}>
			{titleIcon && <NameViewWithTag src={titleIcon} />}
			{name}
		</NameView>
	);
};

export interface PriceViewsLayout {
	hasLineBreak?: boolean;
}
interface PriceViewsProps {
	productPrice: ProductCurrencyPrice;
	columnNum: number;
	layout?: PriceViewsLayout;
	className?: string;
}
const PriceViews = ({ productPrice, columnNum, className = "", layout }: PriceViewsProps) => {
	const {
		price,
		priceCurrency,
		priceSymbol,
		originPrice,
		originPriceCurrency,
		originPriceSymbol,
	} = productPrice;
	return (
		<PriceView gridCol={columnNum} hasLineBreak={layout?.hasLineBreak} className={className}>
			{price && (
				<span className={"price"}>
					{priceCurrency ? `${priceCurrency} ` : ""}
					{priceSymbol}
					{isNaN(+price) ? price : Number(price)}
				</span>
			)}
			{originPrice && originPrice !== price && (
				<OriginalPriceView hasLineBreak={layout?.hasLineBreak}>
					{originPriceCurrency ? `${originPriceCurrency} ` : ""}
					{originPriceSymbol}
					{isNaN(+originPrice) ? originPrice : Number(originPrice)}
				</OriginalPriceView>
			)}
		</PriceView>
	);
};
interface CollectViewsProps {
	collect: PoolExtraCollectInfo;
}
const CollectViews = ({ collect }: CollectViewsProps) => {
	return <CollectViewOrange>{collect?.text}</CollectViewOrange>;
};

const ActTagViewForM = ({
	actTags = [],
	style = {},
}: {
	actTags: string[];
	style?: React.CSSProperties;
}) => {
	return (
		<ActTagViewForMGrid style={style}>
			{(actTags || []).map((item, index) => (
				<img key={`${item}${index}`} src={item} alt="" />
			))}
		</ActTagViewForMGrid>
	);
};
